import { mutatorAction } from 'satcheljs';
export default mutatorAction('updateVirtualSelectAllExclusionList', function updateVirtualSelectAllExclusionList(tableView, rowKey) {
    // Update row exclusion list in select all mode when a user selects/unselects any row.
    var rowIndex = tableView.virutalSelectAllExclusionList.indexOf(rowKey);
    if (rowIndex > -1) {
        tableView.virutalSelectAllExclusionList.splice(rowIndex, 1);
    }
    else {
        tableView.virutalSelectAllExclusionList.push(rowKey);
    }
});
//# sourceMappingURL=updateVirtualSelectAllExclusionList.js.map